"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.TAB_VERTICAL_PADDING = exports.TAB_HORIZONTAL_PADDING = exports.TAB_BAR_PADDING = exports.SELECTION_INDICATOR_HEIGHT = exports.INVERTED_COLOR_SCHEME = exports.DEFAULT_COLOR_SCHEME = void 0;

var _interfaces = require("./interfaces");

var defaultProps = {
  colorScheme: _interfaces.TabsColorScheme.Default,
  shouldActivateManually: true
};
exports.defaultProps = defaultProps;
var DEFAULT_COLOR_SCHEME = {
  mainColor: 'primary70',
  hoverColor: 'neutral10'
};
exports.DEFAULT_COLOR_SCHEME = DEFAULT_COLOR_SCHEME;
var INVERTED_COLOR_SCHEME = {
  mainColor: 'neutral0',
  hoverColor: 'neutral70'
};
exports.INVERTED_COLOR_SCHEME = INVERTED_COLOR_SCHEME;
var TAB_VERTICAL_PADDING = 'S200';
exports.TAB_VERTICAL_PADDING = TAB_VERTICAL_PADDING;
var TAB_HORIZONTAL_PADDING = 'S200';
exports.TAB_HORIZONTAL_PADDING = TAB_HORIZONTAL_PADDING;
var TAB_BAR_PADDING = 'S100';
exports.TAB_BAR_PADDING = TAB_BAR_PADDING;
var SELECTION_INDICATOR_HEIGHT = 4;
exports.SELECTION_INDICATOR_HEIGHT = SELECTION_INDICATOR_HEIGHT;